import {
  Box,
  DialogTitle,
  IconButton,
  Dialog as MuiDialog,
  Typography,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import theme from 'src/themes/theme';
import useTranslation from 'next-translate/useTranslation';
import { DialogProps } from './Dialog.types';

export const Dialog = ({ ...props }: DialogProps) => {
  const {
    title,
    dialogTestId,
    closeButtonTestId,
    subtitle,
    handleClose,
    children,
    ...rest
  } = props;
  const { t } = useTranslation('common');
  return (
    <MuiDialog {...rest} onClose={handleClose} data-testid={dialogTestId}>
      <Box
        sx={{
          paddingLeft: theme.spacing(2),
          paddingTop: theme.spacing(2.5),
          paddingBottom: theme.spacing(2.5),
          display: 'flex',
          gap: '10px',
          flexWrap: 'wrap',
        }}
      >
        <DialogTitle
          sx={{
            color: theme.palette.text.primary,
            fontWeight: '700',
            padding: 0,
          }}
        >
          {title}
        </DialogTitle>
        {subtitle && (
          <Typography sx={{ color: '#6F7174', lineHeight: '1.7rem' }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      <IconButton
        aria-label="close"
        data-testid={closeButtonTestId}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.primary.main,
        }}
        title={t('closeWindowButton')}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      {children}
    </MuiDialog>
  );
};
